<template>
	<div>
		<div class="card p-2 flex-row justify-content-end">
			<button class="btn btn-primary" @click="openCreateParentColorModal">Agregar</button>
		</div>

		<div class="card p-2">
			<div class="mx-2 m-2 position-relative">
				<b-row>
					<b-col
						cols="12"
						md="12"
						lg="4"
						class="d-flex align-items-center justify-content-start justify-content-sm-start"
					>
						<span class="text-muted">
							Mostrando {{ pagination.from }} a {{ pagination.to }} de {{ pagination.total }} registros
						</span>
					</b-col>
					<b-col cols="12" md="12" lg="8" class="flex-nowrap">
						<div class="flex flex-wrap cross-center w-full gap-x-3 xt-search-input justify-content-end">
							<div class="xt-search-input__paginate">
								<b-pagination
									v-model="current_page"
									:total-rows="pagination.total"
									:per-page="pagination.perpage"
									first-number
									last-number
									prev-class="prev-item"
									next-class="next-item"
								>
									<template #prev-text>
										<feather-icon icon="ChevronLeftIcon" size="18" />
									</template>
									<template #next-text>
										<feather-icon icon="ChevronRightIcon" size="18" />
									</template>
								</b-pagination>
							</div>
							<div class="xt-search-input__search">
								<div class="search-container-value">
									<b-form-input
										type="search"
										class="search-input"
										@keyup.enter="init"
										v-model="search"
										placeholder="Nombre"
										style="width: 200px"
									/>
									<div class="search-btn">
										<button @click="init" class="btn btn-primary w-100">Buscar</button>
									</div>
								</div>
							</div>
						</div>
					</b-col>
				</b-row>
			</div>

			<div class="table-responsive mb-0">
				<b-table
					class="mt-2"
					ref="configure-reason-table"
					id="configure-reason-table"
					sticky-header="60vh"
					show-empty
					:busy.sync="isBusy"
					responsive="sm"
					:items="colours"
					:fields="fields"
				>
					<template #table-busy>
						<div class="text-center text-primary my-2">
							<b-spinner class="align-middle mr-1" />
							<strong>Loading ...</strong>
						</div>
					</template>
					<template #cell(index)="row">
						{{ pagination.from + row.index }}
					</template>
					<template #cell(name)="{ item }">
						<div class="d-flex align-items-center justify-content-between">
							<p class="mb-0 font-weight-bolder">{{ item.color }}</p>
							<FeatherIcon
								@click="openModalUpdateName(item.id, item.color)"
								icon="EditIcon"
								size="18"
								class="text-primary cursor-pointer mx-50"
							/>
						</div>
					</template>
					<template #cell(gender)="{ item }">
						<div class="d-flex justify-content-center">
							<v-select
								v-model="item.gender_id"
								label="label"
								:options="genders"
								:reduce="(opt) => opt.id"
								:clearable="false"
								transition=""
								placeholder="Seleccione un género"
								class="w-50"
								@input="updateColor($event, item.id)"
							/>
						</div>
					</template>
					<template #cell(specimen_counter)="{ item }">
						<div
							:class="item.specimen_counter ? 'underline-hover' : ''"
							class="d-flex align-items-center justify-content-center"
							@click="item.specimen_counter ? openSpecimensByColorModal(item) : null"
						>
							<p class="mb-0 font-weight-bolder">{{ item.specimen_counter }}</p>
						</div>
					</template>
					<template #cell(children)="row">
						<div class="d-flex justify-content-center align-items-center">
							<b-badge
								v-if="row.item.children.length"
								variant="primary"
								style="width: 50px"
								@click="row.toggleDetails"
								class="cursor-pointer"
							>
								<feather-icon
									class="text-white"
									:icon="row.detailsShowing ? 'ChevronUpIcon' : 'ChevronDownIcon'"
									size="21"
								/>
							</b-badge>
							<b-badge
								v-else
								variant="secondary"
								style="width: 50px"
								class="cursor-not-allowed text-white"
							>
								<feather-icon icon="MinusIcon" size="21" />
							</b-badge>
						</div>
					</template>
					<template #cell(actions)="row">
						<div class="d-flex justify-content-center align-items-center">
							<b-button variant="flat-success" @click="openCreateChildColorModal(row.item)">
								<feather-icon class="text-success" icon="PlusIcon" size="21" />
							</b-button>
							<b-button
								v-if="row.item.children.length === 0 && !row.item.specimen_counter"
								variant="flat-danger"
								@click="deleteColor(row.item.id)"
							>
								<FeatherIcon icon="TrashIcon" size="20" class="text-danger cursor-pointer mx-50" />
							</b-button>
							<b-button
								v-if="row.item.specimen_counter"
								@click="openChangeSpecimenColorModal(row.item)"
								variant="flat-warning"
								v-b-tooltip.hover.top="'Migrar ejemplares'"
							>
								<FeatherIcon icon="ShuffleIcon" />
							</b-button>
						</div>
					</template>
					<template #row-details="row">
						<b-card class="m-0 p-0 custom-card">
							<b-table-simple class="mt-1" sticky-header="60vh">
								<b-tbody>
									<b-tr class="text-center" v-for="(colour, index) in row.item.children" :key="index">
										<b-td class="" style="width: 300px">
											<div class="d-flex align-items-center justify-content-between">
												<p class="mb-0 font-weight-bolder">{{ colour.color }}</p>
												<FeatherIcon
													@click="openModalUpdateName(colour.id, colour.color)"
													icon="EditIcon"
													size="18"
													class="text-primary cursor-pointer mx-50"
												/>
											</div>
										</b-td>

										<b-td class="">
											<div class="d-flex justify-content-center">
												<v-select
													v-model="colour.gender_id"
													label="label"
													:options="genders"
													:reduce="(opt) => opt.id"
													:clearable="false"
													transition=""
													placeholder="Seleccione un género"
													class="w-50"
													@input="updateColor($event, colour.id)"
												/>
											</div>
										</b-td>
										<b-td class="" style="width: 150px">
											<div
												:class="colour.specimen_counter ? 'underline-hover' : ''"
												class="d-flex align-items-center justify-content-center"
												@click="
													colour.specimen_counter ? openSpecimensByColorModal(colour) : null
												"
											>
												<p class="mb-0 font-weight-bolder">{{ colour.specimen_counter }}</p>
											</div>
										</b-td>
										<b-td>
											<FeatherIcon
												v-if="!colour.specimen_counter"
												@click="deleteColor(colour.id)"
												icon="TrashIcon"
												size="18"
												class="text-danger cursor-pointer mx-50"
											/>
											<b-button
												v-if="colour.specimen_counter"
												@click="openChangeSpecimenColorModal(colour)"
												variant="flat-warning"
												v-b-tooltip.hover.right="'Migrar ejemplares'"
											>
												<FeatherIcon icon="ShuffleIcon" />
											</b-button>
										</b-td>
									</b-tr>
								</b-tbody>
							</b-table-simple>
						</b-card>
					</template>
				</b-table>
			</div>
		</div>

		<b-modal
			@ok="updateNameColor(modalUpdateName.color_id, modalUpdateName.color_text)"
			ok-title="Guardar"
			size="xs"
			centered
			v-model="modalUpdateName.show"
			:title="modalUpdateName.title"
		>
			<b-form-group label="Color">
				<b-form-input v-model="modalUpdateName.color_text" trim></b-form-input>
			</b-form-group>
		</b-modal>

		<b-modal
			@hide="hideModalCreate"
			@ok.prevent="createColor"
			v-model="modalCreateColor.show"
			:title="modalCreateColor.title"
		>
			<validation-observer ref="form">
				<ValidationProvider rules="required" v-slot="{ errors }" class="w-100">
					<b-form-group label="Color" :invalid-feedback="errors[0]" :state="errors[0] ? false : null">
						<b-form-input
							placeholder="Agregar nombre"
							v-model="modalCreateColor.name"
							trim
							:class="errors[0] ? 'is-invalid' : ''"
							@input="
								(e) => {
									modalCreateColor.name = modalCreateColor.name.toUpperCase()
								}
							"
						></b-form-input>
					</b-form-group>
				</ValidationProvider>
			</validation-observer>

			<b-form-group label="Genero">
				<v-select
					v-model="modalCreateColor.gender_id"
					label="label"
					:options="genders"
					:reduce="(opt) => opt.id"
					:clearable="false"
					transition=""
					placeholder="Seleccione un género"
					class="w-100"
				/>
			</b-form-group>
		</b-modal>
		<SpecimensByColorModal
			v-if="showSpecimensByColorModal"
			:color="selectedColor"
			@close="showSpecimensByColorModal = false"
		/>
		<ChangeSpecimenColorModal
			v-if="showChangeSpecimenColorModal"
			:color="selectedColor"
			@refresh="init"
			@close="showChangeSpecimenColorModal = false"
		/>
	</div>
</template>

<script>
import specimensService from "@/services/specimens.service"
import SpecimensByColorModal from "@/views/brain/specimens/views/colors/components/SpecimensByColorModal.vue"
import ChangeSpecimenColorModal from "@/views/brain/specimens/views/colors/components/ChangeSpecimenColorModal.vue"
import { create } from "lodash"
export default {
	name: "ColourSpecimenSettings",
	components: {
		SpecimensByColorModal,
		ChangeSpecimenColorModal,
	},
	data() {
		return {
			selectedColor: null,
			showSpecimensByColorModal: false,
			showChangeSpecimenColorModal: false,
			isBusy: false,
			fields: [
				{
					key: "index",
					label: "#",
					visible: true,
					thClass: "text-center",
					tdClass: "text-center",
				},
				{
					key: "name",
					label: "Nombre",
					visible: true,
					thClass: "text-center",
					tdClass: "text-center",
					thStyle: "width: 400px",
				},
				{ key: "gender", label: "Genero", visible: true, thClass: "text-center", tdClass: "text-center" },
				{
					key: "specimen_counter",
					label: "Ejemplares",
					visible: true,
					thClass: "text-center",
					tdClass: "text-center",
				},
				{
					key: "children",
					label: "Ver hijos",
					visible: true,
					thClass: "text-center",
					tdClass: "text-center",
				},

				{ key: "actions", label: "Acciones", visible: true, thClass: "text-center", tdClass: "text-center" },
			],
			genders: [
				{
					id: null,
					label: "Ambos",
				},
				{
					id: 1,
					label: "Macho",
				},
				{
					id: 2,
					label: "Hembra",
				},
			],
			colours: [],
			modalUpdateName: {
				show: false,
				title: "Actualizar color",
				color_id: null,
				color_text: null,
			},
			modalCreateColor: {
				show: false,
				title: "Agregar",
				name: null,
				gender_id: null,
				parent_id: null,
			},
			current_page: 1,
			pagination: {
				perpage: 20,
				from: 1,
				to: 1,
				total: 1,
			},
			search: null,
		}
	},
	async mounted() {
		await this.init()
	},
	methods: {
		openCreateParentColorModal() {
			this.modalCreateColor.show = true
			this.modalCreateColor.title = "Agregar"
			this.modalCreateColor.parent_id = null
		},
		openCreateChildColorModal(parent) {
			this.modalCreateColor.show = true
			this.modalCreateColor.title = "Agregar color hijo de " + parent.color
			this.modalCreateColor.parent_id = parent.id
		},
		openChangeSpecimenColorModal(color) {
			this.selectedColor = color
			this.showChangeSpecimenColorModal = true
		},
		openSpecimensByColorModal(color) {
			this.selectedColor = color
			this.showSpecimensByColorModal = true
		},
		async init() {
			this.isPreloading()
			const {
				colores: { data, from, last_page, to, total },
			} = await specimensService.getColors({
				gender_specimen: null,
				page: this.current_page,
				perpage: this.pagination.perpage,
				search: this.search,
			})
			this.isPreloading(false)
			this.pagination.from = from
			this.pagination.to = to
			this.pagination.total = total
			this.colours = data.map((color) => {
				return {
					...color,
					gender_id_copy: color.gender_id,
				}
			})
		},
		async updateColor(gender_id, color_id) {
			const { isConfirmed } = await this.showConfirmSwal()
			if (!isConfirmed) return
			this.isPreloading()
			const { message, success, status } = await specimensService.updateColourSpecimen({
				color_id,
				gender_id,
			})
			this.isPreloading(false)
			if (status) {
				this.showToast("success", "top-right", "Colores", "SuccessIcon", message)
			} else {
			}
			await this.init()
		},
		async deleteColor(color_id) {
			const { isConfirmed } = await this.showConfirmSwal()
			if (!isConfirmed) return
			this.isPreloading()
			const { message, success, status } = await specimensService.deleteColourSpecimen({ color_id: color_id })
			this.isPreloading(false)
			if (status) {
				this.showToast("success", "top-right", "Colores", "SuccessIcon", message)
			} else {
			}
			await this.init()
		},
		openModalUpdateName(color_id, color_text) {
			this.modalUpdateName.show = true
			this.modalUpdateName.color_id = color_id
			this.modalUpdateName.color_text = color_text
		},
		//
		async updateNameColor(id, text) {
			this.isPreloading()
			const resp = await specimensService.updateNameColourSpecimen({ color_id: id, color_text: text })
			this.isPreloading(false)
			await this.init()
		},
		async createColor() {
			if (!(await this.$refs.form.validate())) {
				this.showToast(
					"danger",
					"top-right",
					"Campos Incompletos",
					"AlertCircleIcon",
					"Faltan campos por llenar"
				)
				return
			}
			this.isPreloading()
			const resp = await specimensService.createColourSpecimen({
				gender_id: this.modalCreateColor.gender_id,
				name: this.modalCreateColor.name,
				parent_id: this.modalCreateColor.parent_id,
			})
			this.isPreloading(false)

			await this.init()
			this.modalCreateColor.show = false
			this.modalCreateColor.name = null
			this.modalCreateColor.gender_id = null
			this.modalCreateColor.parent_id = null
		},
		hideModalCreate() {
			// this.modalCreateColor.show = false;
			// this.modalCreateColor.name = null;
			// this.modalCreateColor.gender_id = null;
		},
	},
	watch: {
		async current_page() {
			await this.init()
		},
	},
}
</script>

<style lang="scss" scoped>
.underline-hover {
	text-decoration: underline;
	transition: all 0.1s ease;
}

.underline-hover:hover {
	font-weight: bold;
	cursor: pointer;
	font-size: 1.2rem;
}
.custom-card {
	border: 3px solid var(--primary);
	border-radius: 10px;
	padding: 1rem;
}
.xt-search-input__search {
	width: 100%;
	// margin: 1rem 0;
	display: flex;
	flex-direction: column;
	@media screen and (min-width: 1400px) {
		flex-direction: row;
		justify-content: flex-end;
	}
	.search-container-type {
		display: flex;
		h4 {
			display: flex;
			align-items: center;
			justify-content: center;
		}
	}
	.search-container-value {
		display: flex;
		flex-direction: column;
		margin-top: 0.5rem;
		@media screen and (min-width: 700px) {
			flex-direction: row;
			// margin-top: .5rem;
			margin-left: 1rem;
		}
		.search-input {
			width: 100% !important;
			@media screen and (min-width: 700px) {
				width: 50% !important;
			}
			@media screen and (min-width: 1000px) {
				width: 50% !important;
			}
		}
		.search-btn {
			margin-top: 0.5rem;
			width: 100% !important;
			@media screen and (min-width: 700px) {
				margin-left: 0.5rem;
				margin-top: 0;
				width: 50% !important;
			}
		}
	}
}
</style>
